import { httpArg, httpBodyArg, httpPost, httpRoute, httpUserId } from '../infrastructure/http/http-decorators';

export interface SetTelegramEmailRequest {
	email: string;
}

@httpRoute('/api/telegram-email')
export abstract class ITelegramEmailConnectionService {
	@httpPost('set-email')
	setEmailForTelegramUser(
		@httpBodyArg() request: SetTelegramEmailRequest,
		@httpUserId() userId?: string
	): Promise<void> {
		void request;
		void userId;
		throw new Error('Not implemented');
	}

	@httpPost('confirm-email')
	confirmUserEmail(
		@httpArg('confirmationToken') confirmationToken: string
	): Promise<void> {
		void confirmationToken;
		throw new Error('Not implemented');
	}
}
